import { BidderDetailModel } from "../models/BidderDetailModel";
import { client } from "./API";

const BidderDetailService = {
  async getProjectBidderDetails(projectId: number) {
    const response = await client({
      method: "GET",
      url: `Project/GetProjectBidderDetails/${projectId}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },

  async postProjectBidderDetails(projectId: number, data: BidderDetailModel[]) {
    try {
      const response = await client({
        method: "post",
        url: `Project/PostProjectBidderDetails/${projectId}`,
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default BidderDetailService;
